export class InstallServiceWorker {
    static async installServiceWorker() {
        if (!("serviceWorker" in navigator)) {
            throw "Service workers are not supported"
        }
        await navigator.serviceWorker.register("/service-worker.js", { type: "module" })
        console.log("Service worker registration successful")
    }

    static async precache(assets: string[]) {
        if (assets?.length > 0) {
            await fetch("./service-worker/precache?assets=" + assets.join(";"))
        }
    }
}
